import MacrosEffect from './MacrosEffect.js';
import PaletteEffect from './PaletteEffect.js';
import RollEffect from './RollEffect.js';
import PlayheadEffect from './PlayheadEffect.js';
import {PLAYHEAD_EFFECT, PALETTE_EFFECT, ROLL_EFFECT, MACROS_EFFECT} from './constants.js';


export const nameToLiveEffect = {
    "Roll Effect": track => new RollEffect(track),
    "Macros": track => new MacrosEffect(track),
//    "Palettes": track => new PaletteEffect(track),
    "Playhead": track => new PlayheadEffect(track),
}

export function getLiveEffect(json, track) {
    if (json.effect === ROLL_EFFECT) {
        let roll = new RollEffect(track);
        return roll;
    }

    if (json.effect === MACROS_EFFECT) {
        let macros = new MacrosEffect(track);
        return macros;
    }

    if (json.effect === PALETTE_EFFECT) {
        let palette = new PaletteEffect(track);
        return palette;
    }

    if (json.effect === PLAYHEAD_EFFECT) {
        let playhead = new PlayheadEffect(track);
        return playhead;
    }

    return undefined;
}
